var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTableIconColor({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.75 1.0957H6.25C2.79822 1.0957 0 3.78199 0 7.0957V23.8957C0 27.2094 2.79822 29.8957 6.25 29.8957H23.75C27.2018 29.8957 30 27.2094 30 23.8957V7.0957C30 3.78199 27.2018 1.0957 23.75 1.0957Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.25 10.2457C6.25 8.50602 7.71907 7.0957 9.53125 7.0957H15H20.4688C22.281 7.0957 23.75 8.50602 23.75 10.2457V15.4957V20.7457C23.75 22.4855 22.281 23.8957 20.4688 23.8957H15H9.53125C7.71907 23.8957 6.25 22.4855 6.25 20.7457V15.4957V10.2457ZM9.53125 9.1957C8.9272 9.1957 8.4375 9.66582 8.4375 10.2457V14.4457H13.9062V9.1957H9.53125ZM16.0938 9.1957V14.4457H21.5625V10.2457C21.5625 9.66582 21.0729 9.1957 20.4688 9.1957H16.0938ZM21.5625 16.5457H16.0938V21.7957H20.4688C21.0729 21.7957 21.5625 21.3257 21.5625 20.7457V16.5457ZM13.9062 21.7957V16.5457H8.4375V20.7457C8.4375 21.3257 8.9272 21.7957 9.53125 21.7957H13.9062Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableIconColor);
export default __webpack_public_path__ + "static/media/tableIconColor.f7ea17b70f5819cc33e53c7f78ae61d8.svg";
export { ForwardRef as ReactComponent };